/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable prefer-arrow/prefer-arrow-functions */
function parseDateElastic(dateString: string): Date {
  const year = parseInt(dateString.substr(0, 4), 10);
  const month = parseInt(dateString.substr(5, 2), 10);
  const day = parseInt(dateString.substr(8, 2), 10);
  return new Date(Date.UTC(year, month - 1, day));
}

export class Favorite {

  static fromObject(object): Favorite {
    let date = null;
    if (object.publish_on) {
      date = parseDateElastic(object.publish_on);
    }

    let pdfId = '';
    if (object.pdf_id) {
      pdfId = object.pdf_id;
    }

    let content = object.content || object.description || '';
    if (content) {
      content = content.slice(0, 100);
      content = content.substr(0, content.lastIndexOf(' ')).concat(' ...');
    }

    let category = '';
    if (object.category_id && object.category_id.name) {
      category = object.category_id.name;
    }

    let sponsorName = '';
    if (object.sponsorising) {
      sponsorName = object.sponsorising.sponsor_name;
    }

    return new Favorite(
      object.id,
      object.slug,
      object.title,
      content,
      date,
      object.type,
      object.newspaper_id.subname,
      pdfId,
      category,
      object.article_sponsored,
      sponsorName
    );
  }

  constructor(
    public id: any,
    public slug: string,
    public title: string,
    public content: string,
    public publishOn: Date,
    public type: string,
    public newspaperSubname: string,
    public pdfId?: string,
    public category?: string,
    public sponsored?: boolean,
    public sponsorName?: string,
    public is_free?: any,
    public article_type?: string,
    public newspaper_subname?: string
  ) {}
}
